import service from "../../../lib";
import { AxiosResponse } from "axios";


type EncodeWheleboneParams<TBody = any> = {
  body: TBody;
};


export type EncodeWheleboneResponse<T = any> = AxiosResponse<T>;

const whaleboneApi = {
  postWhaleboneEncode: <T = any, TBody = any>({
    body,
  }: EncodeWheleboneParams<TBody>): Promise<EncodeWheleboneResponse<T>> => {
    return service.post<T>("/whalebone/encode", body);
  },
}

  export default whaleboneApi;